import { Alert, Link } from '@janeapp/burrito-design-system';
import { hasFeatureFlag } from '@janeapp/feature-flags-client';

const AlertContent = () => {
  if (hasFeatureFlag('NORTH_VANCOUVER_BETA')) {
    return (
      <span data-testid="splash-panel-alert-content-north-van">
        Now available in Squamish, West Vancouver, and North Vancouver.{' '}
      </span>
    );
  } else {
    return (
      <span data-testid="splash-panel-alert-content-squamish">
        Jane&apos;s Practitioner Search is an experimental way to find and book
        last-minute appointments. Not in Squamish?{' '}
      </span>
    );
  }
};

export const NewProductAlert = () => {
  return (
    <Alert>
      <Alert.Content data-testid="splash-panel-alert-content">
        <AlertContent />
        <Link
          href="https://forms.gle/YDNu66kj26XY27ja7"
          target="_blank"
          className="font-thin"
          aria-label="Request your city"
        >
          Request your city
        </Link>
      </Alert.Content>
    </Alert>
  );
};
